import React, { useState, useEffect } from "react";
import { Modal, Tabs, Row, Col, Typography, Divider, Button } from "antd";
import axios from "axios";
import FieldsCategoryTabs from "./FieldsCategoryTabs";
import { Colors } from "theme";
import { gaEvent } from "analytics/analytics";
import * as GA from "constants/analytics";
import API_KEY from "api";
const { TabPane } = Tabs;
const { Text, Title } = Typography;
export default function FieldsModal({
  data,
  isVisible,
  setFieldsModalVisible,
  setTableData,
  setSaving,
  setShowTour,
  collectionDetails,
}) {
  const [fieldsData, setFieldsData] = useState(null);
  const [loading, setLoading] = useState(false)
  useEffect(() => {
    if (data) {
      const newData = data.map((cat) => {
        return {
          ...cat,
          values: cat?.values.map((product) => {
            return {
              ...product,
              attributes: product?.attributes.map((attr) => {
                return {
                  ...attr,
                  visible: product?.visible_attributes?.includes(
                    `${attr?.attribute_id}`
                  ),
                };
              }),
            };
          }),
        };
      });

      setTableData(newData);
      setFieldsData(newData);
    }
  }, []);
  const [activeTab, setActiveTab] = useState("0");

  const handleCheckboxChange = (e, attribute, category) => {
    const newData = fieldsData;

    for (let i = 0; i < newData.length; i++) {
      const cat = newData[i];

      if (cat?.id === category?.id) {
        for (let j = 0; j < cat.values.length; j++) {
          let product = cat.values[j];
          let visibleAttrs = product.visible_attributes
            ? product.visible_attributes
            : [];

          if (visibleAttrs.includes(`${attribute?.id}`)) {
            visibleAttrs.splice(visibleAttrs.indexOf(`${attribute?.id}`), 1);
            product.visible_attributes = visibleAttrs;
          } else {
            visibleAttrs.push(`${attribute?.id}`);
            product.visible_attributes = visibleAttrs;
          }
        }
      }
    }

    setFieldsData([...newData]);
  };
  const onChangeTab = (key) => {
    setActiveTab(key);
  };
  const next = () => {
    setActiveTab((state) => `${parseInt(state) + 1}`);
  };
  const prev = () => {
    setActiveTab((state) => `${parseInt(state) - 1}`);
  };
  const updateCollection = (name, id) => {
    API_KEY.URL.patch(`${API_KEY.path.collections}/${id}`, {
      collection_name: name,
    })
      .then((response) => {
        console.log("Catalogue Updated");
      })
      .catch((err) => {});
  };

  const finish = () => {
    const { collection_name: name, id } = collectionDetails;
    updateCollection(name, id);

    const visited = localStorage.getItem("new");
    console.log(visited === "true");

    const attributesVisibility =
      fieldsData?.length > 0
        ? fieldsData.map((item) => ({
            keys: item?.values?.map((value) => value?.collection_product_id),
            data: {
              visible_attributes: item?.values?.map(
                (value) => value?.visible_attributes
              )
                ? [
                    ...new Set(
                      item?.values
                        ?.map((value) => value?.visible_attributes)
                        .flat()
                    ),
                  ].join(",")
                : [],
            },
          }))
        : [];

    const user = JSON.parse(localStorage.getItem("user"));
    setLoading(true);
    axios
      .post(
        `${process.env.REACT_APP_API_SERVICE}items/collection_products?token=${user?.access_token}`,
        attributesVisibility
      )
      .then((res) => {
        setSaving(false)
        setLoading(false);
        setFieldsModalVisible(false);
        const newItem = localStorage.getItem("new");
    if (newItem === "true") {
      setTimeout(() => {
        setShowTour(true);
      }, 1000);
      // document.body.style.overflow = "hidden";
    } else {
      localStorage.setItem("new", false);
      // document.body.style.overflow = "auto";
    }
      })
      .catch((err) => {
        setSaving(false)
        setLoading(false);

      });
    

    

    setTableData([...fieldsData]);
  };
  const oneCategory = () => (
    <>
      {" "}
      <Row>
        <FieldsCategoryTabs
          handleCheckboxChange={handleCheckboxChange}
          category={fieldsData?.[0]}
          index={fieldsData?.[0]?.id}
        />
      </Row>
      <Divider />
      <Row justify="end">
      <Col span={6}>
      <Button
       loading={loading}
                    style={{
                      color: "white",
                      backgroundColor: "black",
                      width: "100%",
                      height: 48,
                      border:0
                    }}
                    size="large"
                    onClick={finish}
                  >
                    Done
                  </Button>
      </Col>
      </Row>
    </>
  );

  return (
    <>
      <Modal
        visible={isVisible}
        footer={null}
        closable={false}
        closeIcon={null}
        width={"50%"}
        centered
        bodyStyle={{ padding: "3em" }}
      >
        <Row>
          <Col span={24}>
            <Title level={3} style={{ margin: 0 }}>
              Customize Buyer View
            </Title>
            <Text type="secondary" style={{ margin: 0 }}>
              Select the details you want to share with the buyer for the{" "}
              {` ${fieldsData?.length} `}
              categories. You can always edit later
            </Text>
          </Col>
          <Divider />
        </Row>

        {fieldsData?.length === 1 ? (
          oneCategory()
        ) : (
          <>
            <Row>
              <Col>
                <Tabs
                  tabBarStyle={{ width: "15em", minHeight: "20em" }}
                  activeKey={`${activeTab}`}
                  tabPosition={"left"}
                  className="customise-fields-tabs"
                  onChange={onChangeTab}
                >
                  {fieldsData?.map((item, index) => (
                    <TabPane
                      tab={
                        <Text
                          ellipsis
                          style={{
                            color:
                              `${activeTab}` === `${index}`
                                ? Colors.primaryColor
                                : "black",
                          }}
                        >
                          {item?.name}
                        </Text>
                      }
                      key={`${index}`}
                    >
                      <FieldsCategoryTabs
                        handleCheckboxChange={handleCheckboxChange}
                        category={item}
                        index={index}
                      />
                    </TabPane>
                  ))}
                </Tabs>
              </Col>
            </Row>
            <Divider />

            <Row justify="space-between">
              <Col span={6}>
                <Button
                  size="large"
                  disabled={activeTab === "0" ? true : false}
                  onClick={() => {
                    prev()
                    gaEvent(GA.EVENT.CLICK, GA.CATEGORY.CREATE_COLLECTION, GA.DESCRIPTION.BUYER_VIEW_DONE_BUTTON);
                  }}
                  style={{ width: "100%", height: 48 }}
                >
                  Previous
                </Button>
              </Col>
              <Col span={6}>
                {activeTab === `${fieldsData?.length - 1}` ? (
                  <Button
                    style={{
                      color: "white",
                      backgroundColor: "black",
                      width: "100%",
                      height: 48,
                      border:0
                    }}
                    size="large"
                    onClick={() => {
                      finish()
                      gaEvent(GA.EVENT.CLICK, GA.CATEGORY.CREATE_COLLECTION, GA.DESCRIPTION.BUYER_VIEW_DONE_BUTTON);
                    }}
                    loading={loading}
                  >
                    Done
                  </Button>
                ) : (
                  <Button
                    style={{
                      color: "white",
                      backgroundColor: "black",
                      width: "100%",
                      height: 48,
                      border:0
                    }}
                    size="large"
                    onClick={() => {
                      next()
                      gaEvent(GA.EVENT.CLICK, GA.CATEGORY.CREATE_COLLECTION, GA.DESCRIPTION.BUYER_VIEW_NEXT_BUTTON);
                    }}
                  >
                    Next
                  </Button>
                )}
              </Col>
            </Row>
          </>
        )}
      </Modal>
    </>
  );
}
